<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">
            <button (dblclick)="delete()" mat-button>Delete</button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
            <button mat-button mat-dialog-close>Close</button>
        </div>
    </div>

    <div class="navigation mobile">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item>
                  <mat-icon>add</mat-icon>
                  <span>New Item</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>content_copy</mat-icon>
                  <span>Duplicate</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>

        </div>
    </div>
</div>

<div mat-dialog-content>    
    <!-- <app-inventory-item [dialog]="dialog" [item]="item"></app-inventory-item> -->

    <ng-container *ngIf="!isLoading">
        <div class="header-container">
            <div class="left">
                <h2>Task #{{task?.id}}</h2>
            </div>
        </div>
        
        <div class="dialog-layout">
            <div class="side-column">
                <div class="info-card card-panel actions-card">
                    <div class="panel-header">
                        <div class="panel-title">Actions</div>
                    </div>
                    <div class="panel-content actions-content">
                        <button class="action-btn primary" (click)="printTask()" mat-raised-button>Print</button>
                        <button class="action-btn ghost" mat-stroked-button>Download</button>
                    </div>
                </div>

                <div class="info-card card-panel">
                    <div class="panel-header">
                        <div class="panel-title">Customer</div>
                    </div>
                    <div class="panel-content">
                        <ap-pick-customer (pickChange)="test()" [(customer)]="task.customer"></ap-pick-customer>
                    </div>
                </div>
        
                <div class="info-card card-panel">
                    <div class="panel-header">
                <div class="panel-title">Status</div>
            </div>
        <div class="panel-content task-status">
            <div class="status-actions">
                <button class="status-btn primary" [class.active]="task.status===TaskStatus.Completed" (click)="updateStatusCompleted()" mat-raised-button>
                    {{ task.status === TaskStatus.Completed ? 'Completed' : 'Mark Completed' }}
                </button>
                <button class="status-btn ghost"
                        [class.active]="isQueued"
                        (click)="isQueued ? unqueueTask() : queueTask()"
                        mat-stroked-button>
                    {{ isQueued ? 'Unqueue' : 'Move to Queue' }}
                </button>
            </div>
            <div class="age-row" *ngIf="task?.date">
                <span class="label">Opened</span>
                <span class="value">{{ getTaskAge(task.date) }}</span>
                <span class="hint">({{ task.date | date:'mediumDate' }})</span>
                    </div>
            <button class="status-btn ghost"
                    [class.active]="task.waitingForParts"
                    [attr.aria-pressed]="!!task.waitingForParts"
                    [disabled]="waitingForPartsUpdating"
                    (click)="toggleWaitingForParts()"
                    mat-stroked-button>
                <mat-icon>{{ task.waitingForParts ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                Waiting for Parts
            </button>
            <p role="alert" *ngIf="waitingForPartsError">{{ waitingForPartsError }}</p>
                </div>
            </div>

            <div class="info-card card-panel invoice-card">
                <div class="panel-header">
                    <div class="panel-title">Invoice</div>
                    <div class="pill subtle" *ngIf="task?.invoice?.number">#{{task.invoice.number}}</div>
                </div>
                <div class="panel-content invoice-content">
                    <div class="invoice-hint" *ngIf="!task?.invoice?.number">No invoice yet for this task.</div>

                    <button *ngIf="task?.invoice?.number"
                            class="action-btn primary"
                            mat-raised-button
                            (click)="openInvoice()"
                            [disabled]="invoiceCreateLoading || aiInvoiceLoading">
                        Open Invoice
                    </button>

                    <ng-container *ngIf="!task?.invoice?.number">
                        <button class="action-btn ghost"
                                mat-stroked-button
                                (click)="createInvoiceForTask()"
                                [disabled]="invoiceCreateLoading || aiInvoiceLoading">
                            {{ invoiceCreateLoading ? 'Creating…' : 'Create Invoice' }}
                        </button>
                        <button class="action-btn primary"
                                mat-raised-button
                                (click)="generateInvoiceFromTask()"
                                [disabled]="aiInvoiceLoading || invoiceCreateLoading">
                            {{ aiInvoiceLoading ? 'Generating…' : 'Generate AI Invoice' }}
                        </button>
                    </ng-container>

                    <div class="invoice-error" *ngIf="aiInvoiceError">{{ aiInvoiceError }}</div>
                </div>
            </div>

            <div class="info-card card-panel parts-card">
                <div class="panel-header">
                    <div class="panel-title">Parts</div>
                    <div class="pill subtle" *ngIf="partsOrders?.length">Linked: {{ partsOrders.length }}</div>
                </div>
                <div class="panel-content parts-content">
                    <div class="parts-hint" *ngIf="partsLoading">Loading linked parts...</div>
                    <div class="parts-error" *ngIf="!partsLoading && partsError">{{ partsError }}</div>

                    <ng-container *ngIf="!partsLoading && !partsError">
                        <div class="parts-list" *ngIf="partsOrders.length > 0; else noPartsLinked">
                            <div class="parts-item" *ngFor="let order of partsOrders">
                                <div class="parts-row">
                                    <div class="parts-title">{{ order.title || 'Untitled order' }}</div>
                                    <span class="pill subtle parts-status" [ngClass]="order.status">
                                        {{ (order.status || 'ordered') | titlecase }}
                                    </span>
                                </div>
                                <div class="parts-meta">
                                    <span *ngIf="order.expectedDate">ETA {{ order.expectedDate | date:'MMM d' }}</span>
                                    <span *ngIf="order.trackingNumber">Tracking {{ order.trackingNumber }}</span>
                                    <span *ngIf="order.orderNumber">Order #{{ order.orderNumber }}</span>
                                </div>
                                <div class="parts-actions">
                                    <button mat-button (click)="openPartsOrder(order)">Open</button>
                                </div>
                            </div>
                        </div>
                        <ng-template #noPartsLinked>
                            <div class="parts-hint">No parts orders linked to this task yet.</div>
                        </ng-template>
                    </ng-container>

                    <div class="parts-footer">
                        <button mat-stroked-button color="primary"
                                (click)="openPartsOrder()"
                                [disabled]="!task?.id">
                            Add parts order
                        </button>
                        <button mat-button class="parts-link" (click)="goToPartsOrdered()">View all</button>
                    </div>
                </div>
            </div>
        </div>

            <div class="main-column">
                <div class="task card-panel">
                    <div class="task-header">
                        <div class="title-stack">
                            <div class="eyebrow">Task Overview</div>
                            <div class="title-row">
                                <h3>Work Summary</h3>
                                <div class="pill subtle" *ngIf="task?.id">#{{ task.id }}</div>
                            </div>
                        </div>
                        <div class="task-meta">
                            <div class="meta-chip">
                                <div class="label">Quote</div>
                                <div class="value">{{ task.quote | human }}</div>
                            </div>
                            <div class="meta-chip" *ngIf="task?.date">
                                <div class="label">Opened</div>
                                <div class="value">{{ task.date | date:'MMM d, y' }}</div>
                            </div>
                        </div>
                    </div>
        
                    <div class="task-grid">
                        <div class="field">
                            <label>Subject</label>
                            <mat-form-field appearance="outline">
                                <input maxlength="30" matInput [(ngModel)]="task.subject" (blur)="save()">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="description-block">
                        <label>Description</label>
                        <mat-form-field appearance="outline">
                            <textarea matInput
                                      cdkTextareaAutosize
                                      cdkAutosizeMinRows="3"
                                      cdkAutosizeMaxRows="8"
                                      [(ngModel)]="task.description"
                                      (blur)="save()"></textarea>
                        </mat-form-field>
                    </div>
                </div>

                <div class="updates-phone-panel">
                    <div class="phone-shell">
                        <div class="phone-status">
                            <span>Updates</span>
                            <span *ngIf="updatePreviewLog.length">{{ updatePreviewLog.length }} sent</span>
                        </div>

                        <div class="phone-messages" *ngIf="updatePreviewLog.length; else noPhoneUpdates">
                            <ng-container *ngFor="let logEntry of updatePreviewLog; let i = index; trackBy: trackByLogEntry">
                                <div class="phone-update">
                                    <div class="bubble">
                                        {{ logEntry.text }}
                                    </div>
                                    <div class="timestamp">
                                        {{ logEntry.date | date:'h:mm aa' }}
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <ng-template #noPhoneUpdates>
                            <div class="phone-empty">
                                No updates yet.
                            </div>
                        </ng-template>

                        <div class="phone-composer">
                            <textarea class="phone-composer-field"
                                      [(ngModel)]="customSmsMessage"
                                      cdkTextareaAutosize
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="4"
                                      maxlength="1600"
                                      placeholder="Text Message"
                                      aria-label="SMS message"></textarea>
                            <button class="phone-send-btn"
                                    type="button"
                                    title="Send SMS"
                                    aria-label="Send SMS"
                                    [disabled]="!task?.customer || !customSmsMessage.trim()"
                                    (click)="sendCustomSmsUpdate()">
                                <mat-icon>arrow_upward</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="sms-template-actions">
                        <button class="sms-template-btn" type="button" mat-stroked-button [disabled]="!task?.customer || hasSmsUpdateBeenSent('received')" (click)="openSmsUpdateDialog('received')">
                            <mat-icon>sms</mat-icon>
                            <span>Initial Message</span>
                        </button>
                        <button class="sms-template-btn" type="button" mat-stroked-button [disabled]="!task?.customer" (click)="openSmsUpdateDialog('in-progress')">
                            <mat-icon>build</mat-icon>
                            <span>In progress</span>
                        </button>
                        <button class="sms-template-btn" type="button" mat-stroked-button [disabled]="!task?.customer" (click)="openSmsUpdateDialog('parts')">
                            <mat-icon>inventory_2</mat-icon>
                            <span>Parts update</span>
                        </button>
                        <button class="sms-template-btn" type="button" mat-stroked-button [disabled]="!task?.customer || hasSmsUpdateBeenSent('ready')" (click)="openSmsUpdateDialog('ready')">
                            <mat-icon>check_circle</mat-icon>
                            <span>Ready</span>
                        </button>
                        <button class="sms-template-btn" type="button" mat-stroked-button [disabled]="!task?.customer || hasSmsUpdateBeenSent('payment')" (click)="openSmsUpdateDialog('payment')">
                            <mat-icon>payments</mat-icon>
                            <span>Payment amount</span>
                        </button>
                        <button class="sms-template-btn" type="button" mat-stroked-button [disabled]="!task?.customer || hasSmsUpdateBeenSent('review')" (click)="openSmsUpdateDialog('review')">
                            <mat-icon>rate_review</mat-icon>
                            <span>Request Google review</span>
                        </button>
                    </div>
                </div>
        
                <div class="comments-card card-panel" *ngIf="false">
                    <div class="comments-header">
                        <div class="title-stack">
                            <div class="eyebrow">Activity</div>
                            <h3>Comments & Updates</h3>
                        </div>
                        <div class="pill subtle" *ngIf="task?.log?.length">{{ task.log.length }} entries</div>
                    </div>

                    <div class="next-action-comment">
                        <div class="question-field">
                            <label>What's the next action?</label>
                            <mat-form-field appearance="outline">
                                <textarea matInput
                                          cdkTextareaAutosize
                                          cdkAutosizeMinRows="2"
                                          cdkAutosizeMaxRows="5"
                                          [(ngModel)]="nextAction"></textarea>
                            </mat-form-field>
                        </div>

                        <div class="question-field">
                            <label>How long will that next action take?</label>
                            <mat-form-field appearance="outline">
                                <input matInput [(ngModel)]="nextActionDuration">
                            </mat-form-field>
                        </div>

                        <div class="question-field">
                            <label>Is anything blocking it?</label>
                            <mat-form-field appearance="outline">
                                <textarea matInput
                                          cdkTextareaAutosize
                                          cdkAutosizeMinRows="2"
                                          cdkAutosizeMaxRows="5"
                                          [(ngModel)]="nextActionBlocker"></textarea>
                            </mat-form-field>
                        </div>

                        <div class="actions">
                            <button class="submit mat-elevation-z2" color="primary" (click)="addNextActionComment()" mat-flat-button>
                                Add Action Comment
                            </button>
                        </div>
                    </div>

                    <div class="add-comment">
                        <mat-form-field appearance="outline">
                            <textarea matInput
                                      cdkTextareaAutosize
                                      cdkAutosizeMinRows="3"
                                      cdkAutosizeMaxRows="6"
                                      [(ngModel)]="newComment"
                                      placeholder="Add comment with notes and line breaks"></textarea>
                        </mat-form-field>
                        <div class="actions">
                            <button class="submit mat-elevation-z2" color="primary" (click)="addComment()" mat-flat-button>Add Comment</button>
                        </div>
                    </div>

                    <div class="comments-empty" *ngIf="!task?.log?.length">
                        No comments yet. Add the first update to set the context.
                    </div>

                    <div class="comments-timeline" *ngIf="task?.log?.length">
                        <ng-container *ngFor="let logEntry of task.log; let i = index; trackBy: trackByLogEntry">
                            <div class="comment">
                                <div class="bullet"></div>
                                <div class="comment-body">
                                    <p>
                                        {{logEntry.text}}
                                    </p>
                                    <div class="comment-footer">
                                        <div class="meta">
                                            {{logEntry.date | date:'h:mm:aa / dd MMM'}}
                                        </div>
                                        <button mat-button color="warn" class="delete" (dblclick)="removeComment(i)">
                                            (x)
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                
                <!-- <app-invoice-task [invoice]="task.invoice" (invoiceSaved)="save($event)"></app-invoice-task> -->


            </div>
        </div>
        </ng-container>
</div>
